'use client';

import { ReactNode, useState } from 'react';
import ModalForm from '../Modal/Modal';
import ModalFormMC from '../Modal/ModalMC';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import React from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';
import LocalizedLink from '../LocalizedLink';

export interface TxtBlockCustomProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  leftBlock: ReactNode | SerializedEditorState;
  rightBlock: ReactNode | SerializedEditorState;
  showButton?: boolean;
  showLink?: boolean;
  btnText?: string;
  btnTag?: string;
  color?: 'green' | 'blue' | 'violet';
  formType?: 'mc' | 'hr' | 'lead';
}

export default function TxtBlockCustom({
  id,
  title,
  leftBlock,
  rightBlock,
  showLink = false,
  showButton = false,
  color = 'green',
  btnText = 'Дізнатися більше про співпрацю',
  formType = 'lead',
  btnTag,
}: TxtBlockCustomProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <>
      <div
        id={id}
        data-meta="TxtBlockCustom"
        className="container mt-12 mx-auto max-w-7xl px-6 lg:px-8"
      >
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
          <CustomRichText
            data={title}
            tag="h2"
            className="text-center text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8 text-white"
          />
          <div className="mt-10 mx-auto grid max-w-xl grid-cols-1 gap-12 text-white lg:max-w-7xl lg:grid-cols-8">
            {leftBlock && (
              <div className="col-span-4 text-white">
                <CustomRichText data={leftBlock} tag="div" />
              </div>
            )}
            {rightBlock && (
              <div className="col-span-4 text-white">
                <CustomRichText data={rightBlock} tag="div" />
              </div>
            )}
          </div>
          {showLink && (
            <div className="mt-10 text-center flex justify-center">
              <LocalizedLink
                href={'/price'}
                className="pl-6 pr-1 py-2 text-md h-fit font-bold text-white uppercase rounded-full w-fit ring-white ring-1 flex gap-2 items-center leading-8"
              >
                <span className="max-sm:text-sm">{btnText}</span>
                <div className={`rounded-full bg-white p-2`}>
                  <ArrowUpRightIcon className="text-green-600 h-4 w-4" />
                </div>
              </LocalizedLink>
            </div>
          )}
          {showButton && (
            <div className="mt-10 text-center">
              <button
                onClick={openForm}
                className="uppercase inline-block rounded-full px-4 py-2 font-bold text-white shadow custom-gradient-green-btn text-sm sm:text-base focus:outline-none focus:shadow-outline"
              >
                {btnText}
              </button>
            </div>
          )}
        </div>
      </div>
      {formType === 'lead' && isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
      {formType === 'mc' && isFormOpen && (
        <ModalFormMC closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
    </>
  );
}
